import { CommandRequestType } from "app/services/authentication/connection/commandRequestType";
import { ICommandParameters } from "app/services/authentication/connection/iCommandParameters";
import { ICommandResponse } from "app/services/authentication/connection/iCommandResponse";
import { ErrorDetails } from "app/services/authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "app/services/authentication/connection/iRequestCommand";

export class SearchForEmailCommand extends IRequestCommand<
ISearchForEmailCommandResponse,
  ErrorDetails,
  ISearchForEmailCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.POST;
  override _commandUrl ='users/searchEmailExists/';
  public override setParameters(parameters: ISearchForEmailCommandParameters) {
    this._commandBody = parameters;
  }
}

export interface ISearchForEmailCommandParameters extends ICommandParameters {
  email?: string;
  role?: string;
  carrierId?: number;
}

export interface ISearchForEmailCommandResponse
  extends ICommandResponse {}
